export { default as Home } from './component'
